require('slick-carousel');

let carousel = $('.mobile-advertising-list');

export default {
  fire() {
    carousel.slick({
      dots: true,
      arrows: false,
      infinite: false,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/advertising-carousel.js